<template>
  <b-container class="py-3">
    <div class="mb-3">
      <div>Network: {{ tNetwork.chainName }}</div>
      <div v-if="account">Account: {{ utils.truncate(account, 18) }}</div>
      <div v-if="balance > 0">
        Balance: {{ utils.bigToCommon(balance, 18, 2) }} BNB
      </div>
      <div v-if="gPrice > 0">Gas Price: {{ formatGasPrice }} gwei</div>
    </div>
    <div>
      <b-input-group prepend="Private Key">
        <b-form-input
          class="text-left"
          :type="isShow ? 'text' : 'password'"
          v-model="privateKey"
          placeholder="Private key..."
        ></b-form-input>
        <b-input-group-append>
          <b-btn @click="isShow = !isShow" variant="light">
            <b-icon-eye-slash-fill></b-icon-eye-slash-fill>
          </b-btn>
          <b-button @click.prevent="onConnect" class="px-3" variant="info">
            Load Info
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div v-if="isLoading" class="text-center mt-3">
      <p>Loading...</p>
      <b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
    </div>
    <div v-else>
      <div class="mt-3" v-if="bSaru > 0">
        <b-form-group
          :label="`KuniSaru (${bSaru}):`"
          v-slot="{ ariaDescribedby }"
        >
          <b-form-checkbox-group
            id="checkbox-kuni-1"
            v-model="saruSelected"
            :options="tokenIds"
            :aria-describedby="ariaDescribedby"
            name="ck-saru-1"
          >
          </b-form-checkbox-group>
        </b-form-group>
        <b-input-group prepend="Address receive: " class="mt-3">
          <b-form-input
            class="text-left"
            type="text"
            placeholder="0x..."
            v-model="receiveAddr"
          ></b-form-input>
          <b-input-group-append>
            <b-button class="px-5" variant="light">
              {{ this.transferTotal }} / {{ this.saruSelected.length }}
            </b-button>
            <b-button class="px-5" variant="success" @click="onTransfer"
              >Transfer</b-button
            >
          </b-input-group-append>
        </b-input-group>

        <b-input-group prepend="Rate" class="mt-3">
          <b-form-input
            max="100"
            class="text-right"
            type="number"
            placeholder="xx.00"
            v-model="rate"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              class="px-4"
              :disabled="saruSelected.length === 0"
              variant="warning"
              @click.prevent="onScholar"
              >Scholarship</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <NFTScholar :mWallet="mWallet" />
  </b-container>
</template>

<script>
import { ethers } from "ethers";
import {
  network,
  balanceNativeOf,
  createWallet,
  fetchMyNft,
  safeTransferFrom,
  provider,
  gasPrice,
  askBatch,
} from "./nft-tool";

import NFTScholar from "./nft-scholar.vue";

export default {
  name: "nft-tool",
  components: { NFTScholar },
  computed: {
    formatGasPrice: function () {
      return ethers.utils.formatUnits(this.gPrice, "gwei");
    },
  },
  data: () => ({
    balance: ethers.constants.Zero,
    privateKey: "",
    isShow: false,
    tNetwork: network,
    account: null,
    bSaru: ethers.constants.Zero,
    rate: 50,
    tokenIds: [],
    saruSelected: [],
    isLoading: false,
    receiveAddr: "",
    isTransfer: true,
    transferTotal: 0,
    gPrice: ethers.constants.Zero,
    mWallet: null,
  }),
  async created() {
    this.gPrice = await gasPrice();
  },
  methods: {
    onConnect: async function () {
      this.transferTotal = 0;
      this.isLoading = true;
      this.mWallet = await createWallet(this.privateKey);
      this.account = this.mWallet.address;
      balanceNativeOf(this.mWallet.address).then((b) => (this.balance = b));
      await this.loadNft();
      this.isLoading = false;
    },
    async loadNft() {
      [this.bSaru, this.tokenIds] = await fetchMyNft(this.account);
      this.tokenIds = this.tokenIds.map((value) => ({
        text: `# ${value}`,
        value,
      }));
    },
    async onScholar() {
      try {
        await askBatch(
          this.mWallet,
          this.saruSelected,
          ethers.utils.parseUnits(`${this.rate}`, 2)
        );
        this.$bvToast.toast("successful!");
      } catch (err) {
        this.$bvToast.toast(
          err.reason || err.message || "KUNI: Unable to process request",
          {
            variant: "warning",
            autoHideDelay: 2000,
            title: "Warning",
          }
        );
      }
    },
    async onTransfer() {
      this.isTransfer = true;
      try {
        let nonce = await provider.getTransactionCount(this.mWallet.address);
        while (this.transferTotal < this.saruSelected.length) {
          await safeTransferFrom(
            this.mWallet,
            this.receiveAddr,
            this.saruSelected[this.transferTotal],
            ++nonce
          );
          this.transferTotal += 1;
        }
        this.$bvToast.toast("successful!");
      } catch (err) {
        this.$bvToast.toast(
          err.reason || err.message || "KUNI: Unable to process request",
          {
            variant: "warning",
            autoHideDelay: 2000,
            title: "Warning",
          }
        );
      }
    },
  },
};
</script>
